function formatNumber(number) {
  return new Intl.NumberFormat('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  }).format(number)
}

export { formatNumber }
